<template>
	<div class="acessar-ata-itens">
		<menu-acoes
			:acoes-menu="acoesMenu"
			:block="block"
			:nome="placeholder"
			:nome-botao="placeholder"
			:outlined="true"
			class="botao-aditivo-apostila"
			cor-de-fundo="grey"
			cor-icone="--v-error-base"
			icone-secondary="arrow_drop_down"
			@criar-aditivo-apostila="$emit('criar-aditivo-apostila')"
			@historico-aditivo-apostila="$emit('historico-aditivo-apostila')"
		></menu-acoes>
	</div>
</template>

<script>
import { permissoes } from '@/core/constants'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import { mapState } from 'vuex'
import { DataUtils } from '@/core/utils'

export default {
	name: 'acessar-ata-itens-btn-aditivo-apostila',
	mixins: [permissoesMixin],
	props: {
		block: {
			type: Boolean,
		},
		isAtaEfetivada: {
			type: Boolean,
		},
	},
	data() {
		return {
			placeholder: 'ADITIVO/APOSTILA',
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
		possuiHistoricoAditivoApostila: {
			get() {
				return this.$store.state.ata.informacoesAta.possuiHistoricoAditivoApostila
			},

			set(novoValor) {
				this.$store.state.ata.informacoesAta.possuiHistoricoAditivoApostila = novoValor
			},
		},

		acoesMenu() {
			const acoes = []

			if (this.isAtaEfetivada) {
				acoes.push(
					this.criarAcaoMenu(
						'Novo Aditivo/Apostila',
						'add_circle',
						'criar-aditivo-apostila',
						this.montarPermissoes(permissoes.aditivoApostilaCriar, permissoes.aditivoApostilaEditar),
						() => !DataUtils.isVencido(this.informacoesAta.fimValidade),
					),
				)
			}

			if (this.possuiHistoricoAditivoApostila) {
				acoes.push(
					this.criarAcaoMenu(
						'Histórico',
						'history',
						'historico-aditivo-apostila',
						this.montarPermissoes(permissoes.aditivoApostilaHistorico),
						() => true,
					),
				)
			}

			return acoes
		},
	},
	watch: {
		possuiHistoricoAditivoApostila: {
			handler(novoValor) {
				this.possuiHistoricoAditivoApostila = novoValor
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		criarAcaoMenu(titulo, iconeNome, evento, authorization, isVisible) {
			return {
				titulo,
				icone: {
					nome: iconeNome,
				},
				evento,
				authorization,
				isVisible,
			}
		},
	},
}
</script>

<style lang="stylus">
.botao-aditivo-apostila .v-btn
	width 10rem !important
</style>
